module.exports = __webpack_public_path__ + "static/media/eye-icon.352b2010.svg";